import r from "react";
import { Text as _ } from "../Text/Text.js";
import { VisuallyHidden as g } from "../VisuallyHidden/VisuallyHidden.js";
import { StaticUserProfile as y } from "./StaticUserProfile.js";
import { cls as h } from "../../helpers/cls.js";
import { IconButton as b } from "../Header/components/IconButton/IconButton.js";
import { FocusHeaderLogo as v } from "./componentes/FocusHeaderLogo/index.js";
import { ArrowLeft as w } from "@olxbr/ds-icons";
import { sendClickEvent as O } from "../Header/utils/sendClickEvent.js";
var S = Object.defineProperty,
  i = Object.getOwnPropertySymbols,
  x = Object.prototype.hasOwnProperty,
  P = Object.prototype.propertyIsEnumerable,
  c = (o, e, t) => e in o ? S(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : o[e] = t,
  L = (o, e) => {
    for (var t in e || (e = {})) x.call(e, t) && c(o, t, e[t]);
    if (i) for (var t of i(e)) P.call(e, t) && c(o, t, e[t]);
    return o;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const m = _ref => {
  let {
    fixed: o,
    title: e,
    inverted: t,
    userProfile: f,
    ctaContent: s,
    logoWithoutLink: d,
    hideLogo: p,
    goBack: a,
    teamKey: l,
    logoProps: n
  } = _ref;
  const {
      tag: u
    } = n != null ? n : {},
    E = d ? "span" : u || "a";
  return r.createElement("header", {
    "data-ds-component": "DS-FocusHeader",
    className: h("olx-focus-header", o && "olx-focus-header--fixed", t && "olx-focus-header--inverted")
  }, r.createElement("nav", {
    className: "olx-focus-header__content"
  }, !!a && r.createElement(b, L({
    onClick: () => {
      typeof a == "function" && a(), O("back");
    },
    tag: typeof a == "string" ? "a" : "button"
  }, typeof a == "string" && {
    href: a
  }), r.createElement(w, {
    "aria-hidden": "true"
  }), r.createElement(g, null, "Voltar")), !p && r.createElement(v, {
    tag: E,
    goBack: a,
    inverted: t,
    logoProps: n
  }), !!e && r.createElement(_.BodyLarge, {
    tag: "h1",
    weight: "semibold"
  }, e), s, f && !!l && r.createElement(y, {
    teamKey: l
  })));
};
m.displayName = "FocusHeader";
export { m as FocusHeader };